import { FormAtylBase } from '../../form-atyl-base'

export class AtylText extends FormAtylBase<string> {
	controlType = 'text'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
